import "../../../css/teacherManagementPage/TeacherList.css"
import LocationCode from "../../../utils/constants/LocationCode";
import {getDateString, phoneNumberWithHyphen} from "../../../utils/Utils";
import {useState} from "react";
import TeacherInChargeModal from "./modal/TeacherInChargeModal";
import TeacherDetailsModal from "./modal/TeacherDetailsModal";

let TeacherList = (props) => {
    let [inChargeModalOpened, setInChargeModalOpened] = useState(false);
    let [detailModalOpened, setDetailModalOpened] = useState(false);
    let [selectedTeacher, setSelectedTeacher] = useState(null);

    let getTeacherList = () => {
        let teacherList = props.teacherList;
        let ret = [];
        for (let teacher of teacherList) {
            if(teacher.leaved)
                continue;
            let teacherid = teacher.teacherid;
            let locationText = LocationCode.text[teacher.location];
            let name = teacher.name;
            let birth = getDateString(new Date(teacher.birth));
            let phone = phoneNumberWithHyphen(teacher.contact);
            let reregFraction = teacher.reRegisterFraction;
            let reregPercent = reregFraction[0] / (reregFraction[1] === 0 ? 1 : reregFraction[1]) * 100
            reregPercent = reregPercent.toFixed(1);

            let reregText = reregPercent + "% (" + reregFraction[0] + "/" + reregFraction[1] + ")"

            let allLessons = teacher.all_lessons;
            let lessonsDone = teacher.lessons_done;

            let lessonPercent = lessonsDone.length / (allLessons.length === 0 ? 1 : allLessons.length) * 100;
            lessonPercent = lessonPercent.toFixed(2);
            let lessonText = lessonPercent + "% (" + lessonsDone.length + "/" + allLessons.length + ")";

            let key = "teacher-info:" + teacherid;

            ret.push(<div className="teacher-list-row" key={key}>
                <div className="teacher-list-cell">
                    <p>{teacherid}</p>
                </div>
                <div className="teacher-list-cell">
                    <p>{locationText}</p>
                </div>
                <div className="teacher-list-cell">
                    <p>{name}</p>
                </div>
                <div className="teacher-list-cell">
                    <p>{birth}</p>
                </div>
                <div className="teacher-list-cell">
                    <p>{phone}</p>
                </div>
                <div className="teacher-list-cell">
                    <p>{reregText}</p>
                </div>
                <div className="teacher-list-cell">
                    <p>{lessonText}</p>
                </div>
                <div className="teacher-list-cell">
                    <div className="teacher-list-button"
                         onClick={(e) => {
                             setSelectedTeacher(teacher);
                             setInChargeModalOpened(true)
                         }}>
                        <p>보기</p>
                    </div>
                </div>
                <div className="teacher-list-cell">
                    <div className="teacher-list-button"
                         onClick={(e) => {
                             setSelectedTeacher(teacher);
                             setDetailModalOpened(true)
                         }}>
                        <p>상세 정보</p>
                    </div>
                </div>
            </div>)
        }
        return ret;
    }
    return (<div className="teacher-list-container">
        <div className="teacher-list-header-border"></div>
        <div className="teacher-list-header">
            <div className="teacher-list-column-cell">
                <p className="teacher-list-column-text">
                    번호
                </p>
            </div>
            <div className="teacher-list-column-cell">
                <p className="teacher-list-column-text">
                    지점
                </p>
            </div>
            <div className="teacher-list-column-cell">
                <p className="teacher-list-column-text">
                    이름
                </p>
            </div>
            <div className="teacher-list-column-cell">
                <p className="teacher-list-column-text">
                    생년월일
                </p>
            </div>
            <div className="teacher-list-column-cell">
                <p className="teacher-list-column-text">
                    휴대폰 번호
                </p>
            </div>
            <div className="teacher-list-column-cell">
                <p className="teacher-list-column-text">
                    재등록률
                </p>
            </div>
            <div className="teacher-list-column-cell">
                <p className="teacher-list-column-text">
                    레슨 횟수
                </p>
            </div>

            <div className="teacher-list-column-cell">
                <p className="teacher-list-column-text">
                    담당학생
                </p>
            </div>

            <div className="teacher-list-column-cell">
                <p className="teacher-list-column-text">
                    상세정보
                </p>
            </div>
        </div>
        <div className="teacher-list">
            {getTeacherList()}
        </div>
        {inChargeModalOpened ? (<TeacherInChargeModal teacher={selectedTeacher}
                                                      setClosed={() => setInChargeModalOpened(false)}
                                                      data={props.data} setNeedUpdate={props.setNeedUpdate}
        />) : null}
        {detailModalOpened ? (<TeacherDetailsModal teacher={selectedTeacher} setNeedUpdate={props.setNeedUpdate}
                                                   setClosed={() => setDetailModalOpened(false)} isRegister={false}
        />) : null}
    </div>)
}
export default TeacherList;